/** Путь держим в коде: переменная окружения несёт только origin, иначе префикс удвоится */
export const MM_API_BASE_PATH = '/api/admin/v1';

export const MM_HTTP_TIMEOUT_MS = 30000;

/** Число повторов запроса при 429 и 5xx; другие коды не повторяем */
export const MM_RETRY_ATTEMPTS = 2;

/** Пауза между повторами, мс (умножается на номер попытки). */
export const MM_RETRY_BASE_DELAY_MS = 400;

export const MM_PAGE_SIZE_DEFAULT = 20;
export const MM_PAGE_SIZE_OPTIONS = ['20', '50', '100'];

function readEnv(name: string): string {
  const raw = process.env[name];

  return typeof raw === 'string' ? raw.trim() : '';
}

function stripTrailingSlash(value: string): string {
  return value.replace(/\/+$/, '');
}

/** Значение по умолчанию только для сборки разработки: в бою пустая переменная даёт явную ошибку */
export const MM_DEFAULT_BACKEND_URL = 'http://localhost:8090';

export function getMobileBackendOrigin(): string {
  const explicit = stripTrailingSlash(readEnv('VUE_APP_MM_BACKEND_URL'));

  if (explicit !== '') {
    return explicit;
  }

  return process.env.NODE_ENV === 'production' ? '' : MM_DEFAULT_BACKEND_URL;
}

export function getMobileBackendBaseUrl(): string {
  const origin = getMobileBackendOrigin();

  return origin === '' ? '' : origin + MM_API_BASE_PATH;
}

/** Без схемы axios не считает адрес абсолютным и приклеивает baseURL повторно при каждом запросе */
export function isMobileBackendConfigured(): boolean {
  const origin = getMobileBackendOrigin();

  return origin !== '' && /^https?:\/\//i.test(origin);
}

/** Переменная необязательная: без неё берётся origin текущего фронта, а не общий адрес SmartPricing */
export function getSpBackendUrlForExchange(): string {
  const explicit = stripTrailingSlash(readEnv('VUE_APP_MM_SP_BACKEND_URL'));

  if (explicit !== '') {
    return explicit;
  }

  return stripTrailingSlash(window.location.origin);
}

export const MM_ENV_VAR_BACKEND_URL = 'VUE_APP_MM_BACKEND_URL';
